/**
 * 模块名称: 考勤统计修改抽屉
 * @author zhuyan@372163.com
 */
import React, { useState, useEffect, useRef } from 'react'
import { Drawer, Form, Input, Select, Button, Upload, message, Icon } from 'antd'
import { upLoadModule } from 'utils/common'
import api from 'api'

const { Option } = Select
const { TextArea } = Input
const FormItem = Form.Item
const { Dragger } = Upload

const StatisticsEditDrawer = (props) => {
  const { visible, onClose, record, onSuccess, form } = props
  const { getFieldDecorator, validateFields, getFieldValue, setFieldsValue, resetFields } = form
  const [modifyTypeOptions, setModifyTypeOptions] = useState([])
  const [currentValue, setCurrentValue] = useState('')
  const [fileList, setFileList] = useState([])
  const [loading, setLoading] = useState(false)
  const draggerRef = useRef(null)

  useEffect(() => {
    if (visible) {
      setCurrentValue('')
      setFileList([])
      api.getCheckTypeSelectList().then(res => {
        setModifyTypeOptions(res || [])
      })
    }
  }, [visible])

  // 修改类型变化
  const handleModifyTypeChange = (value) => {
    const selectedType = modifyTypeOptions.find(item => item.key === value)
    if (selectedType && record && record[selectedType.key] !== undefined) {
      setCurrentValue(record[selectedType.key])
    } else {
      setCurrentValue('')
    }
    setFieldsValue({
      afterData: ''
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    validateFields((err, vals) => {
      let uploadList = []
      for (let i = 0, k = fileList.length; i < k; i++) {
        if (fileList[i].status !== 'removed') {
          uploadList.push({
            url: fileList[i].url,
            name: fileList[i].name
          })
        }
      }
      if (!err) {
        setLoading(true)
        vals.id = record.id
        vals.beforeData = +vals.beforeData
        vals.afterData = +vals.afterData
        vals.affix = JSON.stringify(uploadList)
        Object.keys(vals).forEach(key => {
          if ([undefined, null, ''].includes(vals[key])) {
            delete vals[key]
          }
        })
        api.postCheckInStatModify(vals).then(() => {
          message.success('修改成功')
          resetFields()
          setFileList([])
          onSuccess && onSuccess()
          onClose()
          setLoading(false)
        }).catch(() => {
          setLoading(false)
        })
      }
    })
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 5 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  const uploadFiles = upLoadModule({
    fileList: fileList,
    setFileList: setFileList,
    draggerRef: draggerRef,
    accept: '.rar, .zip, .doc, .docx, .pdf, .jpg, .jpeg, .png, .bmp, .pptx, .PDF, .csv, .xlsx',
    allowSizeType: 4
  })

  return (
    <Drawer
      title="考勤统计修改"
      width={600}
      onClose={() => {
        resetFields()
        onClose()
      }}
      visible={visible}
      destroyOnClose={true}
    >
      <div className="statistics-drawer-container">
        {record && (
          <div className="statistics-drawer-info">
            <div className="info-item">
              <span className="label">公司用名:</span>
              <span className="value">{record.userName || '--'}</span>
            </div>
            <div className="info-item">
              <span className="label">考勤月份:</span>
              <span className="value">{record.month || '--'}</span>
            </div>
            <div className="info-item">
              <span className="label">直属上级:</span>
              <span className="value">{record.lead || '--'}</span>
            </div>
            <div className="info-item">
              <span className="label">员工编号:</span>
              <span className="value">{record.no || '--'}</span>
            </div>
            <div className="info-item">
              <span className="label">所属公司:</span>
              <span className="value">{record.cropName || '--'}</span>
            </div>
            <div className="info-item">
              <span className="label">所属部门:</span>
              <span className="value">{record.sectionName || '--'}</span>
            </div>
          </div>
        )}

        <Form onSubmit={handleSubmit} {...formItemLayout}>
          <FormItem
            label="修改类型"
          >
            {getFieldDecorator('type', {
              rules: [{ required: true, message: '请选择修改类型' }]
            })(
              <Select
                placeholder="请选择修改类型"
                onChange={handleModifyTypeChange}
                allowClear
              >
                {modifyTypeOptions.map(option => (
                  <Option key={option.key} value={option.key}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
          <FormItem
            label="当前数值"
          >
            {getFieldDecorator('beforeData', {
              initialValue: currentValue
            })(
              <Input readOnly className="no-border-input" />
            )}
          </FormItem>
          <FormItem
            label="修改结果"
          >
            {getFieldDecorator('afterData', {
              rules: [{
                required: true,
                message: '请输入修改结果'
              }, {
                validator: (rule, value, callback) => {
                  const type = getFieldValue('type')
                  if (!value) {
                    callback()
                    return
                  }
                  const numValue = parseFloat(value)
                  if (isNaN(numValue)) {
                    callback('请输入有效的数字')
                    return
                  }
                  if (numValue < 0) {
                    callback('请输入正数')
                    return;
                  }
                  if (type === 'things' || type === 'absenteeism' || type === 'mealAllowance') {
                    // 事假或旷工、饭补，允许保留两位小数的数字
                    if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                      callback('请输入最多保留两位小数的数字')
                      return
                    }
                  } else {
                    // 其他情况，只能输入0.5倍数的正数
                    if (numValue % 0.5 !== 0) {
                      callback('请输入0.5倍数的正数')
                      return
                    }
                  }
                  callback()
                }
              }]
            })(
              <Input placeholder="请输入修改结果" />
            )}
          </FormItem>
          <FormItem label="上传附件">
            <div className="dragger-box" ref={draggerRef}>
              <Dragger
                {...uploadFiles}
              >
                <p className="ant-upload-drag-icon">
                  <Icon type="inbox" />
                </p>
                <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
                <p className="ant-upload-hint">
                  支持扩展名：.rar, .zip, .doc, .docx, .pdf, .jpg, .jpeg, .png, .bmp, .pptx, .PDF, .csv, .xlsx
                </p>
              </Dragger>
            </div>
          </FormItem>
          <FormItem
            label="备注"
          >
            {getFieldDecorator('remark')(
              <TextArea rows={4} placeholder="请输入备注" />
            )}
          </FormItem>
        </Form>
        <div style={{ position: 'absolute', bottom: 0, width: '100%', borderTop: '1px solid #e8e8e8', padding: '16px', textAlign: 'right', left: 0, background: '#fff' }}>
          <Button onClick={() => {
            resetFields()
            setFileList([])
            onClose()
          }} style={{ marginRight: 8 }} disabled={loading}>
            取消
          </Button>
          <Button onClick={handleSubmit} type="primary" loading={loading}>
            确定
          </Button>
        </div>
      </div>
    </Drawer>
  )
}

export default Form.create()(StatisticsEditDrawer)